<div
  #panel
  id="text-ai-panel"
  class="improve-with-ai-panel"
  [class.attribute-editor-show-from-right]="shown"
  role="region"
  [attr.aria-label]="panelLabel"
  tabindex="-1"
>
  <div class="improve-with-ai-content">
    <div class="improve-with-ai-chip-list" aria-label="Improve text actions">
      @for (option of presetOptions; track option.id) {
        <rv-badge
          class="improve-with-ai-chip"
          mode="button"
          color="gray"
          [text]="option.label"
          [icon]="option.icon || null"
          [loading]="isActionLoading(option.id)"
          [disabled]="!hasText"
          (activated)="onActionClick(option)"
        />
      }
    </div>

    <section class="improve-with-ai-section" aria-labelledby="tone-heading">
      <h3 id="tone-heading" class="improve-with-ai-section-title">Tone</h3>
      <div class="improve-with-ai-chip-list">
        @for (option of toneOptions; track option.id) {
          <rv-badge
            class="improve-with-ai-chip"
            mode="button"
            color="gray"
            [text]="option.label"
            [emoji]="option.emoji || null"
            [loading]="isActionLoading(option.id)"
            [disabled]="!hasText"
            (activated)="onActionClick(option)"
          />
        }
      </div>
    </section>

    <section
      class="improve-with-ai-section improve-with-ai-custom-section"
      aria-labelledby="custom-heading"
    >
      <label
        id="custom-heading"
        class="improve-with-ai-section-title"
        for="text-ai-custom-prompt"
      >
        Custom
      </label>
      <textarea
        id="text-ai-custom-prompt"
        class="improve-with-ai-custom-prompt"
        rows="3"
        [(ngModel)]="customPrompt"
        [disabled]="isActionLoading('custom')"
        placeholder="What would you like to write?"
      ></textarea>
      <button
        type="button"
        class="improve-with-ai-generate-button"
        [class.loading]="isActionLoading('custom')"
        [disabled]="!canGenerateCustomPrompt()"
        [attr.aria-busy]="isActionLoading('custom')"
        (click)="onCustomPromptGenerate()"
      >
        @if (isActionLoading('custom')) {
          <span class="improve-with-ai-spinner" aria-hidden="true"></span>
          <span class="tw-sr-only">Generate Text loading</span>
        } @else {
          <span>Generate Text</span>
        }
      </button>
      @if (messageType) {
        <div
          class="improve-with-ai-message"
          [class.error]="messageType === 'error'"
          aria-live="polite"
        >
          @switch (messageType) {
            @case ('no-credits') {
              <span>You don't have enough credits. </span>
              @if (canAccessCompanySettings()) {
                <a
                  class="improve-with-ai-message-link"
                  [uiSref]="'apps.settings.company-details'"
                >
                  See my credits.
                </a>
              }
            }
            @case ('default') {
              <span>Text generation uses credits. </span>
              @if (canAccessCompanySettings()) {
                <a
                  class="improve-with-ai-message-link"
                  [uiSref]="'apps.settings.company-details'"
                >
                  See my credits.
                </a>
              }
            }
            @case ('error') {
              <span>Something went wrong. Please try again.</span>
            }
          }
        </div>
      }
    </section>
  </div>
</div>
